<template>
  <div class="md-layout text-center mt-4 login-page-wrapper">
    <div
      class="md-layout-item md-size-33 md-medium-size-50 md-small-size-70 md-xsmall-size-100"
    >
      <form @submit.prevent="register">
        <login-card class="mb-0">
          <div slot="title" class="image-container logo  logoregister mt-4 pt-4">
            <img v-if="currentLogo" :src="currentLogo" alt="Logo" />
          </div>

          <div class="md-field menu-language registermenu" slot="inputs" v-if="false">
            <i class="fas fa-globe text-secondary"></i>
            <select
              class="md-select text-secondary"
              id="language-select"
              v-model="selectedLanguage"
              @change="changeLanguage"
            >
              <option value="en">English 🇬🇧</option>
              <option value="es">Español 🇪🇸</option>
              <option value="fr">Français 🇫🇷</option>
              <option value="pt">Português 🇵🇹</option>
              <option value="uk">Українська 🇺🇦</option>
            </select>
          </div>

          <template v-if="showconfirm">
            <h4 class="my-2 align-center text-center" slot="inputs">
              {{ $t("confirmEmailText") }}
            </h4>
            <p
              v-if="registrationWarning"
              class="text-center small text-warning register-confirm-text"
              slot="inputs"
            >
              {{ registrationWarning }}
            </p>
            <p class="text-center register-confirm-text" slot="inputs">
              {{ $t("registerConfirmSpamP1") }}
              <strong
                ><a
                  class="text-primary"
                  href="https://chat.whatsapp.com/L32mTz6n8k08sHGvnDnvWU"
                  target="_blank"
                  rel="noopener noreferrer"
                  >{{ $t("registerConfirmWhatsapp") }}</a
                ></strong
              >
            </p>
          </template>

          <template v-else>
            <div class="md-field md-form-group" slot="inputs">
              <i class="fas fa-user"></i>
              <input
                class="md-input register-input"
                v-model="form.name"
                type="text"
                :placeholder="$t('name') + ' *'"
                @input="clearError('name')"
              />
              <span v-if="errors.name" class="error">{{ errors.name }}</span>
            </div>

            <div class="md-field md-form-group countryregister" slot="inputs" v-if="false">
              <i class="fas fa-globe "></i>
              <CountrySelect
                :usei18n="false"
                v-model="form.country"
                :country="form.country"
                @input="clearError('country')"
              />
              <span v-if="errors.country" class="error">{{ errors.country }}</span>
            </div>

            <template v-if="showBusinessRegistrationFields">
              <div class="md-field md-form-group" slot="inputs">
                <i class="fas fa-building "></i>
                <input
                  class="md-input register-input"
                  v-model="form.restaurant"
                  type="text"
                  :placeholder="$t('businessName') + ' *'"
                  @change="checkRestaurantName"
                  @input="clearError('restaurant')"
                />
                <i v-if="errors.restaurant" class="error">{{ errors.restaurant }}</i>
                <i v-if="errors.restaurantexist" class="error">{{ errors.restaurantexist }}</i>
              </div>

              <small slot="inputs" class="register-help-text">
                <i class="fas fa-circle text-primary sm-icon"></i>
                <span class="text-primary">{{ $t("registerHelpBusinessUrl") }}</span>
              </small>

              <p
                slot="inputs"
                class="text-start small text-secondary mb-2 px-1"
              >
                {{ registerDedicatedDbHelp }}
              </p>

              <div slot="inputs">
                <span v-if="form.restaurant" class="text-secondary"
                  >https://{{ getUrlName() }}.iajur.com</span
                >
              </div>

              <div class="md-field md-form-group" slot="inputs">
                <i class="fas fa-link"></i>
                <input
                  class="md-input register-input"
                  v-model="form.companyLink"
                  type="text"
                  :placeholder="$t('registerCompanyLinkPlaceholder')"
                />
              </div>

              <small slot="inputs" class="register-help-text">
                <i class="fas fa-circle text-primary sm-icon"></i>
                <span class="text-primary">{{ $t("registerHelpCompanyLink") }}</span>
              </small>
            </template>

            <div class="md-field md-form-group" slot="inputs">
              <i class="fas fa-envelope "></i>
              <input
                class="md-input register-input"
                v-model="form.email"
                type="email"
                :placeholder="$t('email') + ' *'"
                @input="clearError('email')"
              />
              <i v-if="errors.email" class="error">{{ errors.email }}</i>
              <i v-if="errorMessage" class="error">{{ errorMessage }}</i>
            </div>

            <small
              v-if="requireRegisterEmailConfirmationOnSite"
              slot="inputs"
              class="register-help-text"
            >
              <i class="fas fa-circle text-primary sm-icon"></i>
              <span class="text-primary">{{
                showBusinessRegistrationFields
                  ? $t("registerHelpEmailConfirmBusiness")
                  : $t("registerHelpEmailConfirmAny")
              }}</span>
            </small>

            <div class="md-field md-form-group" slot="inputs">
              <i class="fas fa-lock "></i>
              <input
                class="md-input register-input"
                v-model="form.password"
                type="text"
                :placeholder="$t('password') + ' *'"
                @input="clearError('password')"
              />
              <span v-if="errors.password" class="error">{{ errors.password }}</span>
            </div>
          </template>

          <div slot="footer">
            <button
              v-if="!showconfirm"
              type="submit"
              class="md-button md-primary md-lg login-submit-btn"
            >
              {{ $t("getStarted") }}
            </button>
            <div class="mt-3">
              <router-link class="gotakeit" :to="{ path: '/login' }">
                {{ $t("login") }}
              </router-link>
            </div>
          </div>
        </login-card>
      </form>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import CountrySelect from "vue-country-select";
import { registerAction, checkNameAction } from "@/pages/Auth/actions";
import { LoginCard } from "@/components";
import { i18n } from "@/i18n";
import { wencesApi } from "@/api/wencesApi";
import Swal from "sweetalert2";

export default {
  components: {
    LoginCard,
  },
  computed: {
    languages() {
      return this.$languages;
    },
    currentLogo() {
      return this.site?.logo || this.logo;
    },
    /** Solo si el admin activó “Register new App”: negocio + URL + BD dedicada. */
    showBusinessRegistrationFields() {
      return !!(this.site && this.site.registerNewApp === true);
    },
    /** Publicado en /api/settings: si false, no hace falta confirmar email para iniciar sesión. */
    requireRegisterEmailConfirmationOnSite() {
      return this.site?.registerRequireEmailConfirmation !== false;
    },
    registerDedicatedDbHelp() {
      if (!this.showBusinessRegistrationFields) return "";
      return this.requireRegisterEmailConfirmationOnSite
        ? this.$t("registerHelpDedicatedDbConfirm")
        : this.$t("registerHelpDedicatedDbImmediate");
    },
  },
  mounted() {
    this.form.country = "AR"; // Aseguramos que Argentina sea seleccionada tras la carga del componente
  },
  async created() {
    const currentUrl = window.location.href;
    const subdomainPattern =
      /^https:\/\/.*\.app\.gotake\.it(?:\/#)?\/register$/;

    if (subdomainPattern.test(currentUrl)) {
      window.location.href = "https://app.gotake.it/register";
      return;
    }

    if (this.$router.currentRoute.params.type) {
      //this.typeregister = this.$router.currentRoute.params.type
    }
    await this.loadSettings();
  },
  data() {
    return {
      typeregister: "gym",
      selectedLanguage: "es",
      logo: "/img/gotakeit.png",
      site: null,
      errorMessage: false,
      showconfirm: false,
      registrationWarning: null,
      form: {
        name: "",
        restaurant: "",
        companyLink: "",
        email: "",
        password: "",
        country: "AR",
      },
      errors: {
        name: null,
        country: null,
        restaurant: null,
        restaurantexist: null,
        email: null,
        password: null,
      },
    };
  },
  methods: {
    async loadSettings() {
      try {
        const response = await wencesApi.get("/api/settings");
        this.site = response?.data?.data || null;
        if (!this.site || this.site.registerNewApp !== true) {
          this.form.restaurant = "";
          this.form.companyLink = "";
          this.clearError("restaurant");
          this.clearError("restaurantexist");
        }
      } catch (error) {
        this.site = null;
        this.form.restaurant = "";
        this.form.companyLink = "";
      }
    },
    changeLanguage() {
      localStorage.setItem("language", this.selectedLanguage);
      i18n.locale = this.selectedLanguage;
    },
    clearError(field) {
      Vue.set(this.errors, field, null);
    },
    getUrlName() {
      return this.form.restaurant
        .toLowerCase() // Convertir a minúsculas
        .normalize("NFD") // Descomponer caracteres con acentos
        .replace(/[\u0300-\u036f]/g, "") // Eliminar marcas diacríticas
        .replace(/\s+/g, "") // Eliminar espacios
        .replace(/[^a-z0-9]/g, ""); // Eliminar caracteres especiales
    },
    validateEmail(email) {
      const re = /\S+@\S+\.\S+/;
      return re.test(email);
    },
    async checkRestaurantName() {
      if (!this.showBusinessRegistrationFields) return;
      this.clearError("restaurantexist");
      if (this.form.restaurant) {
        try {
          const res = await checkNameAction(this.form.restaurant);
          if (res.exists) {
            Vue.set(
              this.errors,
              "restaurantexist",
              this.$t("nameAlreadyTaken")
            );
          }
          return false;
        } catch (error) {
          Vue.set(
            this.errors,
            "restaurantexist",
            this.$t("errorCheckingRestaurantName")
          );
          return false;
        }
      } else {
        return false;
      }
      return true;
    },
    validateForm() {
      let valid = true;
      if (!this.form.name) {
        Vue.set(this.errors, "name", this.$t("nameRequired"));
        valid = false;
      }
      if (this.showBusinessRegistrationFields) {
        if (!this.form.restaurant) {
          Vue.set(this.errors, "restaurant", this.$t("restaurantNameRequired"));
          valid = false;
        } else if (this.errors.restaurant) {
          valid = false;
        }
        if (this.errors.restaurantexist) {
          valid = false;
        }
      }

      if (!this.form.country) {
        Vue.set(this.errors, "country", this.$t("countryRequired"));
        valid = false;
      } else if (this.errors.country) {
        valid = false;
      }

      if (!this.form.email) {
        Vue.set(this.errors, "email", this.$t("emailRequired"));
        valid = false;
      } else if (!this.validateEmail(this.form.email)) {
        Vue.set(this.errors, "email", this.$t("emailInvalid"));
        valid = false;
      }
      if (!this.form.password) {
        Vue.set(this.errors, "password", this.$t("passwordRequired"));
        valid = false;
      }
      return valid;
    },
    handleRegisterClick() {
      window.gtag_report_conversion("https://app.gotake.it/register/gym");
    },
    async register() {
      if (this.validateForm()) {
        try {
          const role =
            (this.site && this.site.registerDefaultRole && String(this.site.registerDefaultRole).trim()) ||
            "restaurant";

          const response = await registerAction(
            this.form.name,
            this.form.password,
            this.form.email,
            this.showBusinessRegistrationFields ? this.form.restaurant : "",
            this.form.country,
            role,
            this.showBusinessRegistrationFields ? this.form.companyLink : ""
          );
          if (response.ok) {
            this.errorMessage = null;
            this.registrationWarning = response.dedicatedAppWarning || null;
            this.showconfirm = !!response.needsEmailConfirmation;
            if (response.needsEmailConfirmation) {
              await Swal.fire({
                title: this.$tn("success") || "Listo",
                text: this.$tn("registerConfirmEmailSent", {
                  email: this.form.email,
                }),
                icon: "success",
              });
            } else {
              await Swal.fire({
                title: this.$tn("success") || "Listo",
                text: response.needsAdminActivation
                  ? "Cuenta creada. Un administrador debe activarla antes de que puedas iniciar sesión."
                  : this.$tn("registerSuccessLogin"),
                icon: "success",
              });
              this.$router.push({ path: "/login" });
            }
            this.handleRegisterClick();
          } else {
            this.errorMessage = response.message || this.$t("userExists");
          }
        } catch (error) {
          this.errorMessage = this.$t("userExists");
        }
      }
    },
  },
};
</script>
<style scoped>

.logoregister {
  margin: 0 auto;
  margin-bottom: 15px;
  max-width: 200px;
}

#language-select{
  border: 0;
    width: 100%;
    color: #333 !important;
    padding-bottom: 21px;
}
.login-page-wrapper {
  min-height: 100vh;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.image-container {
  margin-top: 17px;
  box-shadow: inherit !important;
  max-width: 400px;
}

.login-page-wrapper :deep(.md-card-login .md-card-header) {
  margin-bottom: 0px !important;
}
.login-page-wrapper :deep(.md-card-login) {
  background: #ffffff !important;
}

.register-logo {
  width: 100%;
  max-height: 96px;
  object-fit: contain;
}

.register-input {
  padding-left: 10px !important;
}

.register-help-text {
  display: block;
  margin: 6px 0 10px;
}

.register-confirm-text {
  margin-top: 8px;
}

.menu-language.registermenu {
  margin-bottom: 6px;
  text-align: left;
}

.countryregister :deep(select) {
  border: 0;
  margin-left: 9px;
  border-bottom: 1px solid #a2a2a2;
  width: 100%;
}

.logoregister {
  margin: 0 auto;
  margin-bottom: 15px;
  max-width: 200px;
}
.gotakeit {
  font-weight: bold;
  cursor: pointer !important;
  color: var(--bs-primary) !important;
}

.error {
  color: red;
  font-size: 12px;
}
</style>
